import type { FC } from 'react';

export const Footer: FC = () => {
  return (
    <div id="footer-container">
      {/* Promotional section with light background */}
      <div className="bg-primary-cream px-4 py-8">
        <div className="max-w-6xl mx-auto">
          <p className="text-primary-navy text-center text-sm md:text-base leading-relaxed">
            ALL SHOTGUN ENTHUSIASTS SHOULD COME OUT FOR A VISIT AND CONSIDER APPLYING FOR MEMBERSHIP. 
            OUR FACILITY IS FOCUSED ON THE NEEDS OF THE SHOTGUN SPORTSMAN AND THROWS SOME OF THE BEST 
            CLAY TARGETS IN THE NORTHEAST.
          </p>
        </div>
      </div>

      {/* Main footer with dark background */}
      <footer id="footer" className="bg-primary-navy text-white py-4">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8">
            {/* Address with location icon */}
            <div className="flex items-center gap-2">
              <svg 
                className="w-5 h-5 text-white" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <a 
                href="https://www.google.com/maps/place/Minute+Man+Sportsman's+Club/@42.515592,-71.2325774,825m/data=!3m1!1e3!4m5!3m4!1s0x89e39f9709784dc3:0x702c8b6b557dbea7!8m2!3d42.5144623!4d-71.2309471"
                className="text-white hover:text-primary-yellow transition-colors duration-200"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="View Minute Man Sportsman's Club location on Google Maps"
              >
                56R Francis Wyman Rd Burlington, MA 01803
              </a>
            </div>

            {/* Phone number with phone icon */}
            <div className="flex items-center gap-2">
              <svg 
                className="w-5 h-5 text-white" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <a 
                href="tel:781-272-7169"
                className="text-white hover:text-primary-yellow transition-colors duration-200"
                aria-label="Call Minute Man Sportsman's Club at 781-272-7169"
              >
                781-272-7169
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};